import * as React from 'react';
import {cn} from '../lib/cn';
import {useCarouselContext} from './CarouselContext';

export const CarouselTrack = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<'div'>
>(({className, style, ...props}, ref) => {
  const {index} = useCarouselContext('CarouselTrack');

  return (
    <div
      ref={ref}
      data-slot="carousel-track"
      className={cn(
        'flex h-full w-full transition-transform duration-300 ease-in-out',
        className,
      )}
      style={{transform: `translateX(-${index * 100}%)`, ...style}}
      {...props}
    />
  );
});

CarouselTrack.displayName = 'CarouselTrack';
